import { Typography } from '@mui/material';

export function PlatformBadge({
  isApp,
  isWeb,
}: {
  isApp?: boolean;
  isWeb?: boolean;
}) {
  return (
    <Typography
      sx={{
        fontWeight: 400,
        whiteSpace: 'nowrap',
      }}
      variant="body2"
      component="p"
    >
      {isApp && 'App'}
      {isApp && isWeb && '/'}
      {isWeb && 'Web'}
      {!isApp && !isWeb && '-'}
    </Typography>
  );
}
